<template>
    <a-button icon="download"  @click="downloadTemplate">{{title}}</a-button>
</template>

<script>
import qs from 'qs'

export default {
  name: 'ExpertTem',
  props: {
    filepath: {
      type: String,
      default: ''
    },
    filename: {
      type: String,
      default: '模板.xlsx'
    },
    title:{
      type: String,
      default: '模板下载'
    }
  },
  mounted () {
  },
  created () {
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    downloadTemplate () { // 下载模板
      const aLink = document.createElement('a')
      const params = {
        filepath: this.filepath,
        filename: this.filename
      }
      aLink.href = '/zj/api/1/common/excel/download?' + qs.stringify(Object.assign(params))
      aLink.setAttribute('download', this.filename) // 设置下载文件名称
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .ant-upload-list-item {
  color: #ff0000;
}
</style>
